module.exports = __webpack_public_path__ + "img/art-48.66af5302.png";